import { Illustrations } from 'Wpds/components/illustration';

export enum EmptyStateVariant {
  actionItemsOpen,
  actionItemsComplete,
}

export const EmptyStates = {
  [EmptyStateVariant.actionItemsOpen]: {
    title: 'Looks like your team is all caught up.',
    subtitle: 'Add an action item to a workspace or just celebrate this moment.',
    imgSrc: Illustrations.person_riding_bike_with_white_bg,
  },
  [EmptyStateVariant.actionItemsComplete]: {
    title: 'Your team hasn’t completed any action items yet.',
    subtitle: 'Be the first one to get it done!',
    imgSrc: Illustrations.person_looking_through_lens_white_bg,
  },
};
